import { render } from "./ForgottenPassword.vue?vue&type=template&id=186b50aa&ts=true"
import script from "./ForgottenPassword.vue?vue&type=script&lang=ts"
export * from "./ForgottenPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__